import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px;
`;

export const ContentWrapper = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PageTitle = styled.h1`
  font-size: 28px;
  color: #1a1a1a;
  margin: 0 0 6px 0;
`;

export const PageDescription = styled.p`
  color: #707070;
  margin: 0;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  gap: 16px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const FooterInfo = styled.p`
  color: #707070;
  margin: 0;
`;
